define.alias("shared/components/shared/plan-recommendation/recommendation", "media/components/shared/plan-recommendation/recommendation");